
            const data = {"name":"check-shield","data":{"viewBox":"0 0 512 512","data":"<path pid=\"0\" d=\"M257 491C46 491 44 143 44 128c0-8 4-15 11-19L247 3c6-4 14-4 20 0l192 106c7 4 11 11 11 19 0 15-2 363-213 363zM87 140c2 59 21 308 170 308s168-249 170-308L257 46zm177 219-108-82 32-42 62 46 91-146 45 28z\"/>","originalColors":[],"stopColors":[]}}
        
                    module.exports = data
                    